'use client';

import { useEffect } from 'react';

import { Button } from '@paction-2.0/ui';

import { trackEvent } from '@/lib/analytics';

import styles from './styles/stageZero.module.scss';

export interface NetworkConfidenceCtasProps {
  breedSlug: string;
  locationSlug?: string;
  /** Encouraging microcopy rendered above the breeder CTA. */
  breederLine: string;
}

const ANALYTICS_CATEGORY = 'network_confidence';

/**
 * Client island for the Network Confidence module. The surrounding copy is
 * server-rendered and crawlable; this component only adds the gtag analytics
 * beacons and stays tiny so the module works without JavaScript.
 */
export function NetworkConfidenceCtas({
  breedSlug,
  locationSlug,
  breederLine
}: NetworkConfidenceCtasProps) {
  const label = `${breedSlug}/${locationSlug ?? 'national'}`;

  useEffect(() => {
    trackEvent({ category: ANALYTICS_CATEGORY, action: 'rendered', label });
  }, [label]);

  return (
    <div className={styles.ctas}>
      <Button
        href="#join-waitlist"
        variant="primary"
        className={styles.primaryCta}
        onClick={() =>
          trackEvent({
            category: ANALYTICS_CATEGORY,
            action: 'purchaser_cta_click',
            label
          })
        }
      >
        Join the Waitlist
      </Button>

      <p className={styles.breederLine}>{breederLine}</p>

      <Button
        href="/provider-signup"
        variant="secondary"
        className={styles.secondaryCta}
        onClick={() =>
          trackEvent({
            category: ANALYTICS_CATEGORY,
            action: 'breeder_cta_click',
            label
          })
        }
      >
        List a Litter
      </Button>
    </div>
  );
}
